(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulk-photo-gallery"] && !Shopify.designMode) return;
  try {
    
  const initializeBulkGallery = (root) => {
    if (!root || root.dataset.galleryInitialized === 'true') return;
    root.dataset.galleryInitialized = 'true';

    const items = Array.from(root.querySelectorAll('[data-gallery-item]'));
    const openButtons = Array.from(root.querySelectorAll('[data-gallery-open]'));
    const moreButton = root.querySelector('[data-gallery-more]');
    const dialog = root.querySelector('[data-gallery-dialog]');
    const dialogImage = root.querySelector('[data-gallery-dialog-image]');
    let activeIndex = 0;

    if (moreButton) {
      moreButton.addEventListener('click', () => {
        const batchSize = Number(moreButton.dataset.batchSize) || 10;
        const hiddenItems = items.filter((item) => item.classList.contains('is-hidden'));
        hiddenItems.slice(0, batchSize).forEach((item) => item.classList.remove('is-hidden'));
        moreButton.hidden = hiddenItems.length <= batchSize;
      });
    }

    if (!dialog || !dialogImage) return;

    const showImage = (index) => {
      activeIndex = (index + openButtons.length) % openButtons.length;
      const trigger = openButtons[activeIndex];
      const thumbnail = trigger.querySelector('img');
      dialogImage.src = trigger.dataset.fullSrc;
      dialogImage.alt = thumbnail ? thumbnail.alt : '';
    };

    openButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        showImage(index);
        dialog.showModal();
      });
    });

    root.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog.close());
    root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => showImage(activeIndex - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(activeIndex + 1));

    dialog.addEventListener('click', (event) => {
      if (!event.target.closest('.bulk-gallery__dialog-image, .bulk-gallery__dialog-button')) dialog.close();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  };

  document.querySelectorAll('[data-bulk-gallery]').forEach(initializeBulkGallery);
  document.addEventListener('shopify:section:load', (event) => {
    initializeBulkGallery(event.target.querySelector('[data-bulk-gallery]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
